import { Link } from 'react-router-dom';
import SearchBox from '@/components/feature/SearchBox';
import { hotTags, sites } from '@/mocks/sites';
import { categories } from '@/mocks/categories';

export default function HeroSection() {
  return (
    <section className="relative w-full overflow-hidden border-b border-background-200">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=abstract%20modern%20geometric%20background%20with%20soft%20blue%20gradient%20shapes%20and%20thin%20grid%20lines%20on%20white%20surface%2C%20minimal%20clean%20portal%20style%2C%20subtle%20elegant%20professional%20design%2C%20no%20text&width=1600&height=700&seq=hero-portal-bg&orientation=landscape"
          alt="网址大全平台背景"
          title="网址大全 - 权威综合资源网站目录平台"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-background-50 via-background-50/90 to-background-50/60"></div>
      </div>

      <div className="relative w-full px-4 py-14 md:px-8 md:py-20">
        <div className="max-w-3xl">
          <span className="inline-flex items-center gap-2 rounded-full border border-primary-200 bg-primary-50 px-3 py-1 text-xs font-medium text-primary-700">
            <i className="ri-verified-badge-line"></i>
            权威综合资源网站目录平台
          </span>
          <h1 className="mt-4 font-heading text-3xl font-bold leading-tight text-foreground-950 md:text-5xl">
            网址大全 · 一站式发现优质网站资源
          </h1>
          <p className="mt-4 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base">
            汇集海量优质网站，覆盖行业、服务、工具、资讯等多领域分类，帮你快速定位目标网站、便捷浏览筛选，提升每一次上网的效率。
          </p>

          <div className="mt-7 max-w-2xl">
            <SearchBox large />
          </div>

          <div className="mt-4 flex flex-wrap items-center gap-2">
            <span className="text-xs text-foreground-500">热门搜索：</span>
            {hotTags.slice(0, 6).map((tag) => (
              <Link
                key={tag}
                to={`/search?q=${encodeURIComponent(tag)}`}
                className="rounded-full border border-background-200 bg-background-50 px-3 py-1 text-xs text-foreground-600 transition-colors hover:border-accent-300 hover:text-accent-700"
              >
                {tag}
              </Link>
            ))}
          </div>

          <dl className="mt-9 flex flex-wrap gap-x-10 gap-y-4">
            <div>
              <dt className="text-xs text-foreground-500">收录网站</dt>
              <dd className="font-heading text-2xl font-bold text-foreground-950">{sites.length}+</dd>
            </div>
            <div>
              <dt className="text-xs text-foreground-500">精选分类</dt>
              <dd className="font-heading text-2xl font-bold text-foreground-950">{categories.length}</dd>
            </div>
            <div>
              <dt className="text-xs text-foreground-500">每日更新</dt>
              <dd className="font-heading text-2xl font-bold text-accent-600">持续</dd>
            </div>
          </dl>
        </div>
      </div>
    </section>
  );
}